// ServeSwitcher.js
import React, { useState, useEffect } from "react";
import ConfirmationDialog from "./ConfirmationDialog";
import { useTheme } from "../config/ThemeContext";

const ServeSwitcher = ({ isServing, matchId, socket }) => {
  const [isOpen, setIsOpen] = useState(false);
  const colors = useTheme();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  const handleConfirm = () => {
    if (matchId && socket) {
      socket.emit("manualServeSwitch", { matchId });
    } else {
      console.warn("⚠️ matchId or socket missing when attempting serve switch");
    }
    setIsOpen(false);
  };

  return (
    <>
      {isServing && (
        <button
          onClick={() => setIsOpen(true)}
          title="Click to manually change serving team"
          className="text-xl focus:outline-none"
        >
          🏐
        </button>
      )}
      {isOpen && (
        <ConfirmationDialog
          title="Switch Serving Team?"
          message="This will manually change the serving team."
          onConfirm={handleConfirm}
          onCancel={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default ServeSwitcher;
